import { render, staticRenderFns } from "./_gymChainId.vue?vue&type=template&id=191172f8"
import script from "./_gymChainId.vue?vue&type=script&lang=js"
export * from "./_gymChainId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports